import api from '@pray/shared/utils/api';

import type { WarmupCampaignListItem, WarmupCampaignListResponse, WarmupCampaignStatus } from './types';

// Full envelope returned by the backend after the switch from
// `sendObjectResponse` to `sendPaginatedListResponseWithTotal`.
type ListEnvelope = {
  responded_at: string;
  object: 'list';
  last_item_identifier: string | number | null;
  data_count: number;
  total: number;
  limit: number;
  offset: number;
  counts?: { all: number; active: number; disabled: number; draft: number; done: number };
  data: WarmupCampaignListItem[];
};

export async function listWarmupCampaigns({
  artistId,
  offset,
  limit,
  status,
}: {
  artistId: string;
  offset?: number;
  limit?: number;
  status?: WarmupCampaignStatus;
}): Promise<WarmupCampaignListResponse<WarmupCampaignListItem>> {
  if (!artistId) throw new Error('Artist ID is required');

  const params: Record<string, string | number> = {};
  if (offset !== undefined) params.offset = offset;
  if (limit !== undefined) params.limit = limit;
  if (status) params.status = status;

  const url = `/web/studio/artists/${artistId}/warmup-campaigns`;
  const response = await api.executeGetRequest<ListEnvelope>(url, params);
  const envelope = response.data;
  return {
    data: envelope.data,
    data_count: envelope.data_count,
    total: envelope.total,
    limit: envelope.limit,
    offset: envelope.offset,
    counts: envelope.counts,
  };
}
